import { MoveableBookFeature } from './moveable-book-feature';
import { environment } from '../../environments/environment';
import { Loggable } from './loggable';
import { Modalable, ResponseStatus } from './modalable';
import { TechnicalFeature } from '@lemberger/lemberger-am';

export class Audio extends MoveableBookFeature implements Loggable, Modalable {

    audioFile: AudioFile;
    url: string;
    zIndex = 5;
    logType = TechnicalFeature.Audio;
    tool: null;
    bypassCheck = false;

    status: ResponseStatus;

    getStatus(): ResponseStatus {
        return this.status;
    }

    getEndpointName(): string {
        return environment.endpointUrls.audios;
    }

    canBypassCheck(): boolean {
        return this.bypassCheck;
    }

    getModalId(): string {
        return 'audioModal';
    }
}

class AudioFile {

    id: number;
    displayFileName: string;
    size: number;
    mimeType: string;
}
